import { useVesselVisitBreadcrumbs } from '@operations/hooks/useVesselVisitBreadcrumbs'
import { CarrierVisitStore } from '@operations/stores/CarrierVisitStore'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { Breadcrumbs } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

interface Props {
  visitId: number
  carrierVisitStore: CarrierVisitStore
  rightRenderOption?: ReactNode
}
export const VesselVisitKPIHeader = observer(
  ({ visitId, carrierVisitStore, rightRenderOption }: Props) => {
    const { t } = useTranslate()
    const title = t('vesselKPI', 'Vessel KPI')

    const vesselVisit = carrierVisitStore.items.find(vesselVisit => vesselVisit.id === visitId)

    const { breadcrumbs } = useVesselVisitBreadcrumbs(vesselVisit)

    return (
      <>
        <Helmet>
          <title>{t('vesselVisitsKPI', 'Vessel Visits KPI')}</title>
        </Helmet>

        <Breadcrumbs items={breadcrumbs} />
        <Header title={title} position='relative' rightRenderOption={rightRenderOption} />
      </>
    )
  },
)
